import {userData}  from './test'
import Vue from 'vue'
export const EventBus = new Vue()
// 存储阻塞节点
export let blockNode = null
let blockNodeList = []
let isRunNodeList = []
let blockNodeResMap = {

}
// 获取下个节点
export function getNextPath (node,res){
  let nextNode = node.branch[0]
  if(res && res.branch!=null || res.branch!= undefined){
    nextNode = node.branch[res.branch]
  }
  console.log('nextNode',nextNode)
  return nextNode
}



// 执行器
async function runHook (node,opts){
  console.log('node1',node)
  const res = await hooksMap[node.action].call(this,node,opts)
  isRunNodeList.push(node.id)
  console.log('runHook-res',res)
  let nextNode = getNextPath(node,res)
  if(nextNode)this.runHook(nextNode,res)
}

// userInfo测试数据
let userInfo = null


// 唤起阻塞节点
export function runBlockNode (){
  EventBus.$emit(blockNode.id)
}
// 阻塞节点
export function setBlockNode (node,handle){
  console.log('setBlockNode',node.id,handle)
  EventBus.$on(node.id,handle)
  blockNodeList.push(node)
}
// 移除阻塞节点
export function removeBlockNode (node){
  EventBus.$off(node.id)
  const idx = blockNodeList.forEach((d,idx)=>{if(d.id == node.id)return idx})
  blockNodeList.splice(idx,1)
}

// 开始
export function useStart (...args){
  console.log('run hook1',this)
  console.log('run hook2',...args)
  return 'Start'
}
// 结束
export function useEnd (){
  console.log('end hook',this)
  return 'End'
}

// 获取登录状态，若未登录，则执行登录弹窗
export function getUserInfo (...args){
  console.log('获取用户信息1',this)
  console.log('获取用户信息2',...args)

  blockNode = args[0]
  // if(userInfo)return userInfo
  this.Loding = true
  return new Promise((resolve,reject) => {
    setBlockNode(blockNode, ()=>{
      console.log('获取用户信息3',this)
      setTimeout(() =>{
        userInfo = userData
        this.Loding = false
        const nextNode = getNextPath(blockNode,userInfo)
        removeBlockNode(blockNode.id)
        return runHook.call(this,nextNode,userInfo) 
      },1000)         
    })
  })
}
// 获取登录状态，若未登录，则执行登录弹窗
export function useUserLogin (){
  console.log('校验登录',this)
  // if(userInfo)return userInfo
  return new Promise((resolve,reject) => {
    const random = Math.random()
    console.log('校验登录1random',random)
    if(random>0.9){
      resolve({userData,branch:1})
    }else{
      resolve({userData:null,branch:0})
    }
  },3000)  
}

// 获取当前用户抽奖资格及状态
export function useGetLotteryEligibility (){
  console.log('获取抽奖状态',this)
  return new Promise((resolve,reject) => {
    setTimeout(() =>{
      let random = Math.random()
      console.log('获取抽奖状态1random',random)
      if(random<0.3){
        resolve({lotteryInfo:{name:'当前用户不能抽奖',},branch:0})
      }else if(random<0.6){
        resolve({lotteryInfo:{name:'红包1',},branch:1})
      }else{
        resolve({lotteryInfo:{name:'红包2',},branch:2})
      }      
    },3000)    
  })   
}
const hooksMap = {
  getUserInfo,
  useStart,
  useEnd,
  useUserLogin,
  useGetLotteryEligibility
}

export default hooksMap